import React from 'react';

const Showcase = ({ items }) => {
    return (
        <>
            {items.map((item, idx) => {
                return (
                    <div key={idx} className='mx-auto my-2 py-2 max-w-6xl'>
                        <h1 className='text-center font-bold text-3xl my-2'>
                            {item.title}
                        </h1>
                        <div className='flex flex-wrap items-center place-content-around '>
                            {item.list.map((item, idx) => {
                                return (
                                    <div
                                        key={idx}
                                        className='flex w-72 md:w-96 mx-auto my-2 p-3 '
                                    >
                                        <div className='max-w-sm bg-white rounded-lg border border-gray-200 shadow-md grow'>
                                            <img
                                                className=''
                                                src={item.image}
                                                alt=''
                                            />
                                            <div className='p-3'>
                                                <h5 className='text-xl font-bold tracking-tight text-gray-900'>
                                                    {item.name}
                                                </h5>
                                            </div>
                                            <div className='mb-2 ml-2'>
                                                <a
                                                    href={item.url}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    className='inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 '
                                                >
                                                    View Certificate
                                                    <svg
                                                        className='ml-2 -mr-1 w-4 h-4'
                                                        fill='currentColor'
                                                        viewBox='0 0 20 20'
                                                        xmlns='http://www.w3.org/2000/svg'
                                                    >
                                                        <path
                                                            fill-rule='evenodd'
                                                            d='M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z'
                                                            clip-rule='evenodd'
                                                        ></path>
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default Showcase;
